import { PaletteOptions } from '@mui/material';
import { novotalkColors } from './themeColors';

export const palette: PaletteOptions = {
    novotalk: novotalkColors,
};